/* Boost V2 — WOW motion pack (Round 2.7)
 * Scroll-reveal, animated counters, magnetic CTAs, 3D card tilt, hero shimmer.
 * All gated by prefers-reduced-motion + IntersectionObserver feature detection.
 */
(function(){
  'use strict';
  if (window.__boostWowReady) return;
  window.__boostWowReady = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;

  /* ===== 1. SCROLL-REVEAL ===== */
  function initScrollReveal(){
    if (!('IntersectionObserver' in window)) return;
    // Targets: every top-level section + key card-like blocks
    var selectors = [
      // Homepage V2 sections (real classes) + their cards for staggered reveal
      '.hp-why', '.hp-why-grid > .pillar',
      '.shipping-ladder',
      '.bob', '.bob-grid > .bob-card',
      '.sbc-section', '.sbc-grid > .sbc-card',
      '.rwp-section', '.rwp-card',
      '.vr-section', '.vr-rail > .vr-card',
      // Legacy / other-page targets (kept; harmless if absent)
      '.complete-setup', '.complete-setup-grid > *',
      '.why-boost', '.why-boost-grid > *',
      '.hp-reviews', '.hp-pinned-review',
      '.ambassador-strip', '.ambassador-card', '.press-logo',
      '.lifestyle-reel', '.lifestyle-reel-grid > *',
      '.ugc-grid', '.ugc-grid-grid > *',
      '.newsletter-inline',
      '.bpdp-section',
      '.bpol-section',
    ];
    var nodes = document.querySelectorAll(selectors.join(','));
    var seen = new WeakSet();
    nodes.forEach(function(el, i){
      if (seen.has(el)) return;
      seen.add(el);
      el.classList.add('wow-reveal');
      // Stagger siblings
      if (el.parentElement && el.parentElement.children.length > 1) {
        var idx = Array.prototype.indexOf.call(el.parentElement.children, el);
        el.style.setProperty('--wow-stagger', (idx * 60) + 'ms');
      }
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) {
          e.target.classList.add('wow-reveal-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    nodes.forEach(function(n){ io.observe(n); });
  }

  /* ===== 2. ANIMATED NUMBER COUNTERS ===== */
  // Any element with class .wow-count or [data-wow-count] OR existing patterns we recognize
  function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }
  function animateNumber(el, end, duration, decimals, prefix, suffix){
    var start = 0, t0 = performance.now();
    decimals = decimals || 0;
    prefix = prefix || ''; suffix = suffix || '';
    function tick(now){
      var p = Math.min(1, (now - t0) / duration);
      var v = start + (end - start) * easeOutCubic(p);
      el.textContent = prefix + (decimals ? v.toFixed(decimals) : Math.round(v).toLocaleString('en-PK')) + suffix;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  function parseTarget(text){
    if (!text) return null;
    var trimmed = text.trim();
    // Match patterns like "4.7", "30hr", "20dB", "PKR 7,000", "Rs. 7,000", "30+"
    var m = trimmed.match(/^([^\d\-]*)(-?[\d,]+(?:\.\d+)?)(.*)$/);
    if (!m) return null;
    var prefix = m[1];
    var numStr = m[2].replace(/,/g, '');
    var suffix = m[3];
    var num = parseFloat(numStr);
    if (isNaN(num)) return null;
    var decimals = numStr.indexOf('.') >= 0 ? (numStr.split('.')[1] || '').length : 0;
    return { num: num, prefix: prefix, suffix: suffix, decimals: decimals };
  }
  function initCounters(){
    if (!('IntersectionObserver' in window)) return;
    // Auto-detect — targets:
    var candidates = document.querySelectorAll(
      '.hp-reviews-rating, .pdp-reviews-pill-rating, ' +
      '.product-feature-stat strong, ' +
      '[data-wow-count]'
    );
    candidates.forEach(function(el){
      if (el.dataset.wowCounted === '1') return;
      var t = parseTarget(el.textContent);
      if (!t) return;
      // Skip if number is 0 or extremely small + non-numeric content dominates
      if (t.num === 0) return;
      el.dataset.wowCounted = '1';
      el.dataset.wowOriginal = el.textContent;
    });
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (!e.isIntersecting) return;
        var el = e.target;
        var t = parseTarget(el.dataset.wowOriginal || el.textContent);
        if (!t) { io.unobserve(el); return; }
        // Start
        el.textContent = t.prefix + (t.decimals ? '0.0' : '0') + t.suffix;
        animateNumber(el, t.num, 1100, t.decimals, t.prefix, t.suffix);
        io.unobserve(el);
      });
    }, { threshold: 0.4 });
    candidates.forEach(function(el){ if (el.dataset.wowCounted === '1') io.observe(el); });
  }

  /* ===== 3. MAGNETIC CTAs ===== */
  function initMagneticButtons(){
    var selectors = [
      '.hero-card-cta',
      '.bpdp-btn-primary',
      '.bcoll-buy',
      '.cart-checkout',
      '.cat-helper-cta',
      '.hero-video-cta',
      '.bhero-video-cta',
      '[data-wow-magnetic]'
    ];
    var btns = document.querySelectorAll(selectors.join(','));
    btns.forEach(function(btn){
      if (btn.dataset.wowMag === '1') return;
      btn.dataset.wowMag = '1';
      btn.classList.add('wow-magnetic');
      var raf = null, tx = 0, ty = 0;
      btn.addEventListener('mousemove', function(e){
        var r = btn.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        // Damp by 0.18 → max ~6-10px pull
        tx = dx * 0.18; ty = dy * 0.18;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function(){ btn.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0)'; });
      });
      btn.addEventListener('mouseleave', function(){
        if (raf) cancelAnimationFrame(raf);
        btn.style.transform = '';
      });
    });
  }

  /* ===== 4. 3D CARD TILT (mousemove) ===== */
  function initTilt(){
    var selectors = [
      '.setup-tile',
      '.bcoll-card',
      '.hero-card',
      '.bob-card',
      '.sbc-card',
      '[data-wow-tilt]'
    ];
    var cards = document.querySelectorAll(selectors.join(','));
    cards.forEach(function(card){
      if (card.dataset.wowTilt === '1') return;
      card.dataset.wowTilt = '1';
      card.classList.add('wow-tilt');
      var raf = null;
      card.addEventListener('mousemove', function(e){
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;  // -0.5 .. 0.5
        var y = (e.clientY - r.top) / r.height - 0.5;
        // Max rotation 4 deg
        var rx = (-y * 4).toFixed(2);
        var ry = (x * 4).toFixed(2);
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function(){
          card.style.transform = 'perspective(900px) rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) translateZ(0)';
        });
      });
      card.addEventListener('mouseleave', function(){
        if (raf) cancelAnimationFrame(raf);
        card.style.transform = '';
      });
    });
  }

  /* ===== 5. HERO HEADLINE SHIMMER (gold sheen sweep on first paint) ===== */
  function initHeroShimmer(){
    var targets = document.querySelectorAll('.hp-dual-hero-title em, .hero-card-title em, .bpdp-summary h1, .bpol-hero h1, .bcoll-hero h1, .bhero-video h2 em');
    targets.forEach(function(el){
      if (el.dataset.wowShimmer === '1') return;
      el.dataset.wowShimmer = '1';
      el.classList.add('wow-shimmer');
    });
  }

  /* ===== 6. CART ADDED FLASH ===== */
  document.addEventListener('boost:cart:added', function(){
    var icon = document.querySelector('[data-cart-open] svg, .header-icon[href="/cart"] svg');
    if (!icon) return;
    icon.classList.remove('wow-flash');
    void icon.offsetWidth;  // restart
    icon.classList.add('wow-flash');
  });

  /* ===== INIT ===== */
  function init(){
    initScrollReveal();
    initCounters();
    initMagneticButtons();
    initTilt();
    initHeroShimmer();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-init after dynamic content (e.g. AJAX filter changes on collection)
  window.addEventListener('boost:wow:refresh', init);
})();
